import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../Button';
export const BannerAction = (props) => (_jsx(Button, { ...props, variant: "tertiary" }));
//# sourceMappingURL=BannerAction.js.map